import type { SearchContext } from '@shared/types/types.ts';

/**
 *
 *
 */
const ASSORTMENTS_WITH_INSTALLMENTS = [
    'Fahrzeuge',
    'Gartengeräte',
    'Kommunikation',
    'Pools',
    'Unterhaltungselektronik',
    'Gebäude',
    'Optik',
    'Reinigungsgeräte',
    'Haushaltsgeräte',
] as const;

/**
 *
 */
const SEARCHTERMS_WITH_INSTALLMENTS = [
    'AirPods',
    'AirPods 4',
    'AirPods Pro',
    'AirPods Pro 2',
    'AirPods Pro 3',
    'AirPods Series 4',
    'AirTag',
    'AirTag 2',
    'Apple',
    'Apple AirPods',
    'Apple AirPods Pro',
    'Apple iMac',
    'Apple iPad',
    'Apple iPad Air',
    'Apple iPad Pro',
    'Apple iPhone',
    'Apple iPhone 13',
    'Apple iPhone 14',
    'Apple iPhone 15',
    'Apple iPhone 16',
    'Apple iPhone 17',
    'Apple iPhone 17e',
    'Apple iPhone 18',
    'Apple iPhone 18 Pro',
    'Apple iPhone 18 Pro Max',
    'Apple iPhone Duo',
    'Apple laptop',
    'Apple MacBook',
    'Apple MacBook Air',
    'Apple MacBook Neo',
    'Apple MacBook Pro',
    'Apple Magic Keyboard',
    'Apple Pencil',
    'Apple Pencil 2',
    'Apple Pencil 3',
    'Apple tablet',
    'Apple TV',
    'Apple Watch',
    'Apple Watch 8',
    'Apple Watch 9',
    'Apple Watch 10',
    'Apple Watch 11',
    'Apple Watch 12',
    'Apple Watch Armband',
    'Apple Watch SE',
    'Apple Watch SE 2',
    'Apple Watch SE 3',
    'Apple Watch Series 10',
    'Apple Watch Series 11',
    'Apple Watch Series 12',
    'Apple Watch Ultra',
    'Apple Watch Ultra 2',
    'Apple Watch Ultra 3',
    'Apple Watch Ultra 4',
    'HomePod',
    'HomePod mini',
    'iMac',
    'iPad',
    'iPad 2021',
    'iPad 2022',
    'iPad 2024',
    'iPad 2025',
    'iPad 2026',
    'iPad 9',
    'iPad 9 generation',
    'iPad 9th gen',
    'iPad 10',
    'iPad 10 generation',
    'iPad 10th gen',
    'iPad 11',
    'iPad 11 generation',
    'iPad 11th gen',
    'iPad A16',
    'iPad Air',
    'iPad Air 2020',
    'iPad Air 2022',
    'iPad Air 2024',
    'iPad Air 2025',
    'iPad Air 2026',
    'iPad Air 5',
    'iPad Air M2',
    'iPad Air M3',
    'iPad Air M4',
    'iPad Apple',
    'iPad mini',
    'iPad mini 6',
    'iPad mini 7',
    'iPad Pro',
    'iPad Pro 11',
    'iPad Pro 12.9',
    'iPad Pro 13',
    'iPad Pro 2021',
    'iPad Pro 2022',
    'iPad Pro 2024',
    'iPad Pro 2025',
    'iPad Pro 2026',
    'iPad Pro M4',
    'iPad Pro M5',
    'iPad stift',
    'iPad tastatur',
    'iPhone',
    'iPhone 12',
    'iPhone 13',
    'iphone 13 256gb',
    'iPhone 13 grün',
    'iPhone 13 mini',
    'iPhone 14',
    'iPhone 14 Pro',
    'iphone 14 Pro 256gb',
    'iPhone 14 Pro Max',
    'iphone 14 Pro max 256gb',
    'iPhone 15',
    'iPhone 15 plus',
    'iPhone 15 Pro',
    'iphone 15 Pro max',
    'iPhone 16 Plus',
    'iPhone 16 Pro Max',
    'iPhone 16 Pro',
    'iPhone 16',
    'iPhone 17',
    'iPhone 17e',
    'iPhone 17 Pro',
    'iPhone 17 Pro Max',
    'iPhone 18 Pro',
    'iPhone 18 Pro Max',
    'iPhone Duo',
    'iPhone Air',
    'iPhone SE',
    'iPhone SE 2022',
    'iPhone SE 3',
    'Mac mini',
    'Mac mini M4',
    'MacBook',
    'MacBook Air',
    'MacBook Air 2022',
    'MacBook Air M1',
    'MacBook Air M2',
    'MacBook Air M3',
    'MacBook Air M4',
    'MacBook Air M5',
    'MacBook Neo',
    'MacBook Pro',
    'MacBook Pro 14',
    'MacBook Pro 2022',
    'MacBook Pro M1',
    'MacBook Pro M2',
    'MacBook Pro M3',
    'MacBook Pro M4',
    'MacBook Pro M5',
    'Mac Studio',
    'Mac Studio M4',
    'Mac Pro',
    'Mac Pro M2 Ultra',
    'Magic Keyboard',
    'neues iPhone',
] as const;

const ASSORTMENTS_SET = new Set(ASSORTMENTS_WITH_INSTALLMENTS.map((item) => item.toLowerCase()));
const SEARCHTERMS_SET = new Set(SEARCHTERMS_WITH_INSTALLMENTS.map((item) => item.toLowerCase()));

export function shouldShowInstallments(searchContext?: SearchContext): boolean {
    const { searchTerm, assortment } = searchContext ?? {};

    return !!(
        (searchTerm && SEARCHTERMS_SET.has(searchTerm.toLowerCase())) ||
        (assortment && ASSORTMENTS_SET.has(assortment.toLowerCase()))
    );
}
